<template>
  <div class="contact">
    <siteHeader />
    <div class="content">
      <div class="container">
        <page-breadcrumb :paths="['关于我们', currentTab]" />
        
        <div class="page-content">
          <div class="left-nav">
            <h3>关于我们</h3>
            <ul>
              <li 
                v-for="tab in tabs" 
                :key="tab.name"
                :class="{ active: currentTab === tab.name }"
                @click="switchTab(tab.name)"
              >
                {{ tab.name }}
              </li>
            </ul>
          </div>

          <div class="right-content">
            <h2>{{ currentTab }}</h2>
            
            <!-- 联系电话内容 -->
            <div v-if="currentTab === '联系电话'" class="contact-info">
              <div class="info-item">
                <p><i class="phone-icon"></i> 咨询电话: 023-65031293  13368263300</p>
              </div>
            </div>
            
            <!-- 地理位置内容 -->
            <div v-else-if="currentTab === '地理位置'" class="location-info">
              <div class="location-item">
                <img src="@/assets/ditu.png" alt="地理位置" class="location-map">
              </div>
            </div>
            
            <!-- 加入我们内容 -->
            <div class="article-content" v-else-if="currentTab === '加入我们' && articleData.length">
              <div v-for="item in articleData" :key="item.id" class="job-listing">
                <div class="job-header">
                  <h3 class="job-title">{{ item.title }}</h3>
                </div>
                <div class="job-description" v-html="item.contents"></div>
              </div>
            </div>
            <div v-else-if="currentTab === '加入我们' && !articleData.length" class="loading">暂无招聘信息...</div>
          </div>
        </div>
      </div>
    </div>
    <siteFooter />
  </div>
</template>

<script>
import PageBreadcrumb from '@/components/Breadcrumb.vue'
import siteHeader from '../components/SiteHeader.vue'
import siteFooter from '../components/SiteFooter.vue'
import { websiteApi } from '@/api'

export default {
  name: 'ContactPage',
  components: {
    'page-breadcrumb': PageBreadcrumb,
    siteHeader,
    siteFooter
  },
  data() {
    return {
      currentTab: '联系电话',
      tabs: [
        { name: '联系电话', categoryId: 35 },
        { name: '地理位置', categoryId: 37 },
        { name: '加入我们', categoryId: 40 }
      ],
      articleData: []
    }
  },
  methods: {
    async switchTab(tabName) {
      this.currentTab = tabName
      await this.fetchArticleData()
    },
    async fetchArticleData() {
      // 只有在"加入我们"标签时才获取文章数据
      if (this.currentTab === '加入我们') {
        const currentTabData = this.tabs.find(tab => tab.name === this.currentTab)
        if (currentTabData) {
          try {
            const response = await websiteApi.getTcTrainArticle({ 
              categoryId: currentTabData.categoryId 
            })
            console.log('API Response:', response); // 调试日志
            if (response && response.code === 200) {
              this.articleData = response.rows || [];
            } else {
              console.error('API返回数据异常:', response);
              this.articleData = [];
            }
          } catch (error) {
            console.error('获取文章数据失败：', error)
            this.articleData = []
          }
        }
      }
    }
  },
  async created() {
    await this.fetchArticleData()
  }
}
</script>

<style scoped>
.content {
  padding: 20px 0 40px 0;
  min-height: calc(100vh - 60px);
  background: transparent;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.page-content {
  display: flex;
  gap: 30px;
  margin-top: 20px;
}

.left-nav {
  width: 200px;
  background: transparent;
  padding: 20px;
  border-radius: 4px;
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.05); */
  position: sticky;
  top: 80px;
  align-self: flex-start;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  color: #dddddd;
}

.left-nav h3 {
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  /* border-bottom: 2px solid #1e88e5; */
  color: #333;
}

.left-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.left-nav li {
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px;
}

.left-nav li:hover {
  background: #e3f2fd;
  /* color: #1e88e5; */
}

.left-nav li.active {
  /* background: #1e88e5; */
  color: #0b0b0b;
}

.right-content {
  flex: 1;
  background: transparent;
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.right-content h2 {
  margin: 0 0 20px 0;
  color: #000000;
  padding-bottom: 10px;
  font-size: 12px;
  border: 1px solid #d8d8d8;
  display: inline-block;
  padding: 8px 15px;
  border-radius: 15px;
  background-color: #d8d8d8;
  /* border-bottom: 2px solid #1e88e5; */
}

.contact-info {
  display: flex;
  flex-direction: column;
}

.info-item {
  padding: 20px;
  background: transparent;
  border-radius: 4px;
  margin-bottom: 15px;
}

.info-item p {
  margin: 10px 0;
  color: #333;
  font-size: 18px;
  line-height: 1.6;
}

.phone-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%231e88e5"><path d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>');
  background-repeat: no-repeat;
  vertical-align: middle;
  margin-right: 10px;
}

.article-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.job-listing {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  border-left: 1px solid #e2e8f0;
  transition: transform 0.2s ease, box-shadow 0.3s ease;
}

.job-listing:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.job-header {
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #edf2f7;
}

.job-title {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.job-description {
  color: #4a5568;
  line-height: 1.6;
  font-size: 14px;
}

.job-description ul {
  padding-left: 20px;
}

.job-description p {
  margin-bottom: 10px;
}

.loading {
  text-align: center;
  padding: 20px;
  color: #666;
}

.location-info {
  display: flex;
  flex-direction: column;
}

.location-item {
  width: 100%;
  margin-bottom: 15px;
}

.location-map {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

@media screen and (max-width: 768px) {
  .content {
    padding: 12px 0 24px;
    min-height: auto;
  }

  .page-content {
    flex-direction: column;
    gap: 16px;
    margin-top: 12px;
  }

  .left-nav {
    width: 100%;
    position: static;
    max-height: none;
    padding: 12px;
    overflow: visible;
  }

  .left-nav ul {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .left-nav li {
    flex-shrink: 0;
    padding: 8px 12px;
    white-space: nowrap;
  }

  .right-content {
    padding: 16px;
  }

  .info-item {
    padding: 12px;
  }

  .info-item p {
    font-size: 15px;
  }

  .job-listing {
    padding: 14px;
  }

  .job-title {
    font-size: 16px;
  }
}
</style> 